
const features = [
  {
    id: 1,
    icon: 'ri-team-line',
    title: '地域密着3,000世帯の実績',
    description: '岡山市を中心に、倉敷市・総社市など近隣エリアで3,000世帯以上のお客様にご利用いただいています。地域の気候や生活スタイルを熟知した提案が可能です。',
  },
  {
    id: 2,
    icon: 'ri-heart-line',
    title: '一人ひとりに寄り添う相談',
    description: 'お客様のライフステージや家族構成、将来の夢に合わせて、最適な保険プランをオーダーメイドでご提案。押し売りは一切いたしません。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '経験豊富なスタッフ',
    description: '保険業界で平均15年以上の経験を持つスタッフが、複雑な保険の仕組みをわかりやすく丁寧に説明します。アフターフォローも万全です。',
  },
];

export default function Features() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C3E50] text-center mb-12 md:mb-16">
          おかやま保険が選ばれる3つの理由
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-[#FAF8F3] rounded-2xl p-8 md:p-10 hover:shadow-lg transition-shadow"
            >
              <div className="w-16 h-16 bg-[#FF9B7A] rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#2C3E50] mb-4">
                {feature.title}
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
